import { datadogRum } from '@datadog/browser-rum';
import { logger } from 'features/logger/logger';

type AppInitailizeRumAction = {
  name: 'appInitialize';
};

type AppActiveRumAction = {
  name: 'appActive';
};

type AppInactiveRumAction = {
  name: 'appInactive';
};

type AppEnableDeveloperFeaturesRumAction = {
  name: 'appEnableDeveloperFeatures';
};

type AppRumActions =
  | AppInitailizeRumAction
  | AppActiveRumAction
  | AppInactiveRumAction
  | AppEnableDeveloperFeaturesRumAction;

type UserLoginRumAction = {
  name: 'userLogin';
};

type UserLogoutRumAction = {
  name: 'userLogout';
};

type UserIdleTimeoutRumAction = {
  name: 'userIdleTimeout';
};

type UserChangeLanguageRumAction = {
  name: 'userChangeLanguage';
  details: {
    from: string;
    to: string;
  };
};

type UserRumActions =
  | UserLoginRumAction
  | UserLogoutRumAction
  | UserIdleTimeoutRumAction
  | UserChangeLanguageRumAction;

type QuestionnaireOpenRumAction = {
  name: 'questionnaireOpen';
};

type QuestionnaireFinishRumAction = {
  name: 'questionnaireFinish';
};

type QuestionnaireCloseRumAction = {
  name: 'questionnaireClose';
};

// Page numbers are not collected for privacy reasons (pages might be conditionally visible)
type QuestionnairePreviousPageRumAction = {
  name: 'questionnairePreviousPage';
};

type QuestionnaireNextPageRumAction = {
  name: 'questionnaireNextPage';
};

// Field name and values are not collected for privacy reasons
// (even field name can can reveal information in case of conditional fields)
type QuestionnaireFieldChangeRumAction = {
  name: 'questionnaireFieldChange';
};

type QuestionnairePostSubmissionDoneRumAction = {
  name: 'questionnairePostSubmissionDone';
};

type QuestionnaireNextPostQuestionnairePageRumAction = {
  name: 'questionnaireNextPostQuestionnairePage';
};

type QuestionnairePreviousPostQuestionnairePageRumAction = {
  name: 'questionnairePreviousPostQuestionnairePage';
};

type QuestionnaireRumActions =
  | QuestionnaireOpenRumAction
  | QuestionnaireFinishRumAction
  | QuestionnaireCloseRumAction
  | QuestionnairePreviousPageRumAction
  | QuestionnaireNextPageRumAction
  | QuestionnaireFieldChangeRumAction
  | QuestionnairePostSubmissionDoneRumAction
  | QuestionnaireNextPostQuestionnairePageRumAction
  | QuestionnairePreviousPostQuestionnairePageRumAction;

type RumAction = AppRumActions | UserRumActions | QuestionnaireRumActions;

export const datadogRumAddCustomAction = (rumAction: RumAction) => {
  logger.debug('Adding Datadog RUM custom action', { details: rumAction });

  if ('details' in rumAction) {
    datadogRum.addAction(rumAction.name, { actionDetails: rumAction.details });
  } else {
    datadogRum.addAction(rumAction.name);
  }
};
